<template>
    <v-layout style="background-color: #FFF" class="mb-4">
        <v-flex>
            <v-layout justify-space-between py-5 px-7>
                <v-flex xs6 class="text-start txt-semi-head centro-darkcolor">
                    {{ $t('page.home.roomOffer.roomTypePrefix') }} {{ type.name }}
                </v-flex>
                <v-flex xs6 class="text-end centro-darkcolor">
                    <template v-if="roomsRemaining">
                        <span class="txt-head centro-darkcolor">{{ roomsRemaining }}</span>
                        {{ $t('page.home.roomOffer.roomRemaining') }}
                    </template>
                    <template v-else>
                        {{ $t('page.home.roomOffer.noRoomRemaining') }}
                    </template>
                </v-flex>
            </v-layout>

            <v-carousel>
                <v-carousel-item
                    v-for="(item, index) in type.gallery"
                    :key="index"
                    :src="item.image"></v-carousel-item>
            </v-carousel>

            <v-layout justify-space-between py-5 px-7 style="margin-top: -7px">
                <v-flex xs6 class="text-start txt-semi-head centro-darkcolor">
                    {{ $t('page.home.roomOffer.pricing', {price: priceDisplay}) }}
                </v-flex>
                <template v-if="roomsRemaining">
                    <v-flex xs6 class="text-end">
                        <v-btn style="border: solid 1px #C4C4C4" @click="getSpecialOffer(type)">{{ $t('page.home.roomOffer.getOffer') }}</v-btn>
                    </v-flex>
                </template>
            </v-layout>
        </v-flex>
    </v-layout>
</template>

<script>
    import {mapActions} from 'vuex'
    import Service from '../services'

    export default {
        name: "RoomOffer",
        props: ['roomsRemaining', 'price', 'type', 'img'],
        computed: {
            priceDisplay () {
                return (this.price / 1000000).toFixed(1)
            }
        },

        methods: {
            ...mapActions('roomSelected', ['onGetSpecialOffer']),
            recordedSender() {
                let data = {
                    user_activity_type_id: 1,
                    uuid: Math.random().toString(36).substring(5, 10) + '-' + Math.random().toString(36).substring(5, 10) + '-' + Math.random().toString(36).substring(5, 10),
                    value: this.$route.path
                };
                // console.log(data)
                Service.record.sendActivityData(data)
            },
            async getSpecialOffer (type) {
                await this.onGetSpecialOffer(type.id)
                await this.$router.push({ name: 'TypeSelector' })
                setTimeout(() => {
                    this.$vuetify.goTo('#room-info');
                }, 100)
            }
        }
    }
</script>

<style scoped>

</style>